/* lua.js generated code 0.3.0 */
const Event = require("hecore/EventDispatcher").Event

require('clover/config/ResourceConfig')
require('clover/utils/SpriteUtil')
require('clover/utils/SmartLoader')
require('hecore/EventDispatcher')

kFrameLoaderType = table(
    [1, 'json', '.json'],
    [1, 'plist', '.plist'],
    [1, 'xml', '.xml'],
    [1, 'zip', '.zip'],
    [1, 'mp3', '.mp3'],
    [1, 'sfx', '.sfx'],
    [1, 'png', '.png'],
    [1, 'jpg', '.jpg'],
    [1, 'pvr', '.pvr'],
    [1, 'skeleton', '.skeleton'],
    [1, 'homejson', '.homejson'],
    [1, 'fnt', '.fnt'],
    [1, 'csb', '.csb'],
    [1, 'pack', '.pack']
)

FrameLoader = xClass('FrameLoader', EventDispatcher)
FrameLoader.prototype.ctor = function() {
    var self = this
    EventDispatcher.prototype.ctor.call(self)
    self.list = table()
    self.loading = false
    self.loaded = 0
    self.total = 0
    self.loader = null
}
FrameLoader.prototype.add = function(resource, type) {
    var self = this
    if (!type) {
        if (typeof resource === 'function') {
            type = 'function'
        }else{
            type = cc.path.extname(resource)
        }
        if (!type) {
            cc.error('No resource type - ' + resource)
            return
        }
    }
    table.insert(self.list, [null, resource, type])
}
FrameLoader.prototype.load = function(skipPlistLoad) {
    var self = this
    if ($len(self.list) < 1) {
        self.onLoaderCompleted()
        return
    }
    var context = self
    if (self.loading) {
        cc.log('ERROR: alread loading')
    } else {
        self.loading = true
        self.loaded = 1
    }
    self.list.shift()
    let rawList = self.list.map(v => {
        return v[1]
    })
    // cc.loader.autoLoad(rawList, function () {
    //     if (self.hasEventListenerByName(Events.kProgress)) {
    //         self.dispatchEvent(Event.new(Events.kProgress, self))
    //     }
    //     context.loaded = context.loaded + 1
    // }, function () {
    //     self.syncLoad(skipPlistLoad)
    //     context.onLoaderCompleted()
    // })

    // this.loader = SmartLoader.create(rawList, {
    //     onProgress() {
    //         if (self.hasEventListenerByName(Events.kProgress)) {
    //             self.dispatchEvent(Event.new(Events.kProgress, self))
    //         }
    //         context.loaded = context.loaded + 1
    //     },
    //     onSuccess() {
    //         self.syncLoad(skipPlistLoad)
    //         context.onLoaderCompleted()
    //     },
    //     onFailure() {
    //         context.onLoaderError()
    //     }
    // })
    this.loader = ResManager.createLoader(rawList, {
        onProgress() {
            if (self.hasEventListenerByName(Events.kProgress)) {
                self.dispatchEvent(Event.new(Events.kProgress, self))
            }
            context.loaded = context.loaded + 1
        },
        onSuccess() {
            self.syncLoad(true)
            context.onLoaderCompleted()
        },
        onFailure(e, errList) {
            context.onLoaderError(e, errList)
        }
    })
    this.total = this.loader.total
    this.loader.load()
}
FrameLoader.prototype.retry = function() {
    this.loader && this.loader.retry()
}
FrameLoader.loadPngOnly = function(filePath, noCacheTexture) {
    var sprite = cc.Sprite.create(filePath)
    if (noCacheTexture) {
        cc.Director.getInstance()
            .getTextureCache()
            .removeTextureForKey(filePath)
    }
    return sprite
}
FrameLoader.loadImageWithPlist = function(filePath) {
    var prefix = filePath.split('.')[0]
    var pngPath = prefix + '.png'
    if (window.mini && window.mini.supportPVR() && ResManager.pvrlists[filePath] ||  __DEBUG && ResManager.pvrtestlists[filePath]){
        // console.log("pvr replace", file.replace(/\.plist$/, '.pvr'))
        pngPath = prefix + '.pvr'
    }
    var pf = ResourceConfigPixelFormat[filePath]
    if (pf != null) {
        SpriteUtil.setTexturePixelFormat(pngPath, pf)
        cc.log('setTexturePixelFormat:', pngPath, pf)
    }
    //print(string.format("loading plist: %s %s", filePath, pngPath))
    SpriteUtil.addSpriteFrames(filePath, pngPath)
}
//----------------------
//force = true 时删除CCSpriteFrameCache中的内容，慎用
//--------------------
FrameLoader.unloadImageWithPlists = function(plists, force) {
    ResManager.release(plists.slice(1))
}

FrameLoader._unloadImageWithPlist = function(filePath, force) {
    // string.split 的返回值被包装成了一个table
    let [prefix, ext] = filePath.split('.')
    var pngPath = prefix + '.png'
    SpriteUtil.removeLoadedPlist(filePath)
    if (force) {
        cc.spriteFrameCache.removeSpriteFramesFromFile(filePath)
    }
}

FrameLoader.unloadImageWithPlist = function(filePath, force) {
    ResManager.release(filePath)
}
//------------------------------------------------------------------
// @resourceSrc		directory path of skeleton animation
// @skeletonName	define in skeleton.xml, such as <dragonBones name="skeletonName" frameRate="24" version="2.3">
// @textureName		define in texture.xml such as <TextureAtlas name="textureName" imagePath="texture.png">
//------------------------------------------------------------------
FrameLoader.loadArmature = function(resourceSrc, skeletonName, textureName) {
    if (ResourceArmaturePixelFormat[resourceSrc] != null) {
        cc.Texture2D.setDefaultAlphaPixelFormat(ResourceArmaturePixelFormat[resourceSrc])
    }
    var groups = resourceSrc.split('/')
    if (groups[1] === 'skeleton') {
        skeletonName = skeletonName || groups[2]
        textureName = textureName || groups[2]
    }
    if (__use_small_res) {
        ArmatureFactory.add(resourceSrc + '@2x', skeletonName, textureName)
    } else {
        ArmatureFactory.add(resourceSrc, skeletonName, textureName)
    }
    // TODO: check TEXTURE2_D_PIXEL_FORMAT_BGR_A8888 - cc.configuration._supportsBGRA8888
    // cc.Texture2D.setDefaultAlphaPixelFormat(cc.TEXTURE2_D_PIXEL_FORMAT_BGR_A8888)
    cc.Texture2D.setDefaultAlphaPixelFormat(cc.TEXTURE2_D_PIXEL_FORMAT_RGB_A8888)
}
FrameLoader.cachePlist = function(plistFilename) {
    var path = plistFilename
    if (_G.__use_small_res) {
        var prefix = string.split(plistFilename, '.')[1]
        path = prefix + '@6x' + '.plist'
    }
    cc.spriteFrameCache.cachePlist(path)
}

FrameLoader.prototype.syncLoad = function(skipPlistLoad) {
    var self = this
    // self.loader.list.forEach(res => {
    //     if (res) {
    //         this.handleResource(res)
    //     }
    // })
    self.list.forEach(res => {
        if (res) {
            this.handleResource(res[1], res[2])
        }
    })
}

FrameLoader.prototype.handleResource = function(resourceSrc, resourceType) {
    // if (resourceType === kFrameLoaderType.plist) {
    //     // if (skipPlistLoad && GameProxy.getInstance().isLowDevice()) {
    //     // FIXME: isLowDevice
    //     // if (skipPlistLoad) {
    //     //     FrameLoader.cachePlist(resourceSrc)
    //     // } else {
    //     FrameLoader.loadImageWithPlist(resourceSrc)
    //     //}
    // } else if (resourceType === kFrameLoaderType.pack) {
    //     let loaderName = getRealResourceName(resourceSrc)
    //     let list = cc.loader.getRes(loaderName)
    //     for (var i = 0; i < list.length; i++) {
    //         FrameLoader.loadImageWithPlist(list[i])
    //     }
    // } else if (resourceType === kFrameLoaderType.json) {
    //     //LayoutBuilder:createWithContentsOfFile(resourceSrc)
    // } else if (resourceType === kFrameLoaderType.skeleton) {
    //     //FrameLoader:loadArmature( resourceSrc )
    // } else if (resourceType === kFrameLoaderType.mp3) {
    //     cc.SimpleAudioEngine.getInstance().preloadMusic(resourceSrc)
    // } else if (resourceType === kFrameLoaderType.sfx) {
    //     //print(resourceSrc)
    //     cc.SimpleAudioEngine.getInstance().preloadEffect(resourceSrc)
    // } else if (resourceType === kFrameLoaderType.homejson) {
    //     HomeConfigManager.getInstance().loadByPath(resourceSrc)
    // }
    // else
    if (resourceType === kFrameLoaderType.csb && resourceSrc instanceof Function) {
      //  console.log("")
       // let specialLoader = resourceSrc();
        var func = resourceSrc.prototype.prefillAnimationCachePool;
       func.apply();
      //  specialLoader.prefillAniMapData = null
    }
}

FrameLoader.prototype.getLength = function() {
    return this.total
}
FrameLoader.prototype.onLoaderCompleted = function() {
    var self = this
    if (self.hasEventListenerByName(Events.kComplete)) {
        self.dispatchEvent(Event.new(Events.kComplete, self))
    }
}
FrameLoader.prototype.onLoaderError = function(e, errList) {
    var self = this
    if (self.hasEventListenerByName(Events.kError)) {
        self.dispatchEvent(Event.new(Events.kError, errList))
    }
}
